import { render } from "./ModalMessage.vue?vue&type=template&id=47421454&scoped=true"
import script from "./ModalMessage.vue?vue&type=script&lang=js"
export * from "./ModalMessage.vue?vue&type=script&lang=js"

import "./ModalMessage.vue?vue&type=style&index=0&id=47421454&rel=scss&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47421454"]])

export default __exports__